import axios from 'axios';

import { LEGAL_AGREEMENT_ACCEPT } from '../../constants/api';
import { handleClickLogout } from '../Header/Header.api';

const handleAgreeOnClick = (setAgreeButtonLoading, setError, hideLegalAgreementModal) => {
  setAgreeButtonLoading(true);
  setError('');

  axios
    .get(LEGAL_AGREEMENT_ACCEPT)
    .then((response) => {
      console.info(response);
      hideLegalAgreementModal();
    })
    .catch((error) => {
      console.error(error);
      setError(
        'There was a problem processing this request. We are sorry for the inconvenience. Please contact the Help Desk at 1-877-927-5672 or try again later.',
      );
    })
    .finally(() => {
      setAgreeButtonLoading(false);
    });
};

const handleDeclineOnClick = (setError, oktaAuth) => {
  setError('');
  handleClickLogout(oktaAuth);
};

export { handleAgreeOnClick, handleDeclineOnClick };
